export var PaymentAmountEnum;
(function (PaymentAmountEnum) {
    PaymentAmountEnum["RewardsAmount"] = "RewardsAmount";
    PaymentAmountEnum["FiatAmount"] = "FiatAmount";
    PaymentAmountEnum["SplitAmount"] = "SplitAmount";
})(PaymentAmountEnum || (PaymentAmountEnum = {}));
export var RewardsAccountMinimumRequirementState;
(function (RewardsAccountMinimumRequirementState) {
    RewardsAccountMinimumRequirementState[RewardsAccountMinimumRequirementState["ALL_ACCOUNT_MEET_MINIMUM_REQUIREMENT"] = 0] = "ALL_ACCOUNT_MEET_MINIMUM_REQUIREMENT";
    RewardsAccountMinimumRequirementState[RewardsAccountMinimumRequirementState["ONE_ACCOUNT_DO_NOT_MEET_MINIMUM_REQUIREMENT"] = 1] = "ONE_ACCOUNT_DO_NOT_MEET_MINIMUM_REQUIREMENT";
    RewardsAccountMinimumRequirementState[RewardsAccountMinimumRequirementState["ALL_ACCOUNT_DO_NOT_MEET_MINIMUM_REQUIREMENT"] = 2] = "ALL_ACCOUNT_DO_NOT_MEET_MINIMUM_REQUIREMENT";
})(RewardsAccountMinimumRequirementState || (RewardsAccountMinimumRequirementState = {}));
export var getRewardsAccountMinimumRequirementState = function (rewardsAccounts) {
    //initilize with TRUE to meet the running condition.
    var allAccountsDoNotMeetMinimumReqirements = true;
    var oneAccountDoNotMeetMinimumRequrement = false;
    rewardsAccounts.map(function (account) {
        var _a;
        if (account &&
            ((_a = account.redemptionMin) === null || _a === void 0 ? void 0 : _a.value) > account.rewardsBalance.value) {
            oneAccountDoNotMeetMinimumRequrement = true;
            if (allAccountsDoNotMeetMinimumReqirements)
                allAccountsDoNotMeetMinimumReqirements = true;
        }
        else {
            allAccountsDoNotMeetMinimumReqirements = false;
        }
    });
    if (allAccountsDoNotMeetMinimumReqirements) {
        return RewardsAccountMinimumRequirementState.ALL_ACCOUNT_DO_NOT_MEET_MINIMUM_REQUIREMENT;
    }
    else if (oneAccountDoNotMeetMinimumRequrement) {
        return RewardsAccountMinimumRequirementState.ONE_ACCOUNT_DO_NOT_MEET_MINIMUM_REQUIREMENT;
    }
    else {
        return RewardsAccountMinimumRequirementState.ALL_ACCOUNT_MEET_MINIMUM_REQUIREMENT;
    }
};
//# sourceMappingURL=rewards.js.map